var _rect, _rect2, _g, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _g2, _circle4, _circle5, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFetchTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 119,
    viewBox: "0 0 118 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1353_7494)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 83,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 89,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#137FFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_7494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4491 94.7126C22.3993 94.662 22.3314 94.6333 22.2603 94.6328C22.1893 94.6323 22.121 94.66 22.0705 94.7099C22.0199 94.7598 21.9912 94.8277 21.9907 94.8987C21.9902 94.9697 22.0179 95.038 22.0678 95.0886L23.0598 96.0912H18.2891C18.2184 96.0912 18.1506 96.1193 18.1006 96.1693C18.0506 96.2194 18.0225 96.2872 18.0225 96.3579C18.0225 96.4286 18.0506 96.4965 18.1006 96.5465C18.1506 96.5965 18.2184 96.6246 18.2891 96.6246H23.0598L22.0678 97.6112C22.0431 97.6361 22.0236 97.6656 22.0103 97.698C21.997 97.7304 21.9902 97.7651 21.9903 97.8002C21.9904 97.8352 21.9975 97.8699 22.011 97.9022C22.0245 97.9345 22.0443 97.9639 22.0691 97.9886C22.094 98.0133 22.1235 98.0328 22.1559 98.0461C22.1883 98.0594 22.223 98.0662 22.2581 98.0661C22.2931 98.0659 22.3278 98.0589 22.3601 98.0454C22.3924 98.0319 22.4218 98.0121 22.4465 97.9872L24.0758 96.3579L22.4491 94.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7318 95.1432C19.7847 95.1435 19.8366 95.128 19.8807 95.0987C19.9249 95.0695 19.9593 95.0277 19.9796 94.9788C19.9999 94.9299 20.0052 94.876 19.9948 94.8241C19.9843 94.7721 19.9587 94.7245 19.9211 94.6872L18.9318 93.6898H23.6998C23.7705 93.6898 23.8383 93.6618 23.8883 93.6117C23.9383 93.5617 23.9664 93.4939 23.9664 93.4232C23.9664 93.3525 23.9383 93.2846 23.8883 93.2346C23.8383 93.1846 23.7705 93.1565 23.6998 93.1565H18.9318L19.9211 92.1618C19.9458 92.137 19.9653 92.1075 19.9786 92.0751C19.9919 92.0427 19.9987 92.0079 19.9986 91.9729C19.9984 91.9379 19.9914 91.9032 19.9779 91.8709C19.9644 91.8385 19.9446 91.8092 19.9198 91.7845C19.8949 91.7598 19.8654 91.7403 19.833 91.727C19.8006 91.7137 19.7658 91.7069 19.7308 91.707C19.66 91.7073 19.5923 91.7356 19.5424 91.7858L17.9131 93.4232L19.5424 95.0605C19.5669 95.0862 19.5962 95.1067 19.6288 95.1209C19.6613 95.1351 19.6963 95.1427 19.7318 95.1432Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 93,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_1353_7494)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 45,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1,
    fill: "#FC5F55"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 1,
    fill: "#FDBB40"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 12,
    r: 1,
    fill: "#34C449"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 88,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.55
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 52,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 33,
    width: 69,
    height: 4,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 41,
    width: 88,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1353_7494)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 65.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 65.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 65.75,
    r: 6.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7544 61.7426L63.2575 61.2457C63.2388 61.227 63.2153 61.2188 63.1907 61.2188C63.1661 61.2188 63.1427 61.2281 63.1239 61.2457L62.2321 62.1375C61.8444 61.8748 61.3867 61.7348 60.9184 61.7355C60.3184 61.7355 59.7184 61.9641 59.2602 62.4223L58.0661 63.6164C58.0487 63.634 58.0389 63.6578 58.0389 63.6826C58.0389 63.7074 58.0487 63.7312 58.0661 63.7488L61.2501 66.9328C61.2688 66.9516 61.2923 66.9598 61.3169 66.9598C61.3403 66.9598 61.3649 66.9504 61.3837 66.9328L62.5778 65.7387C63.3852 64.9301 63.4802 63.6797 62.8626 62.768L63.7544 61.8762C63.7907 61.8387 63.7907 61.7789 63.7544 61.7426ZM59.7841 66.4055C59.7665 66.388 59.7427 66.3782 59.7179 66.3782C59.6931 66.3782 59.6693 66.388 59.6516 66.4055L58.8712 67.1859L57.813 66.1277L58.5946 65.3461C58.6309 65.3098 58.6309 65.25 58.5946 65.2137L58.1681 64.7871C58.1504 64.7697 58.1266 64.7599 58.1018 64.7599C58.077 64.7599 58.0533 64.7697 58.0356 64.7871L57.254 65.5687L56.7501 65.0648C56.7413 65.0561 56.7309 65.0492 56.7194 65.0446C56.708 65.0399 56.6957 65.0377 56.6833 65.0379C56.6599 65.0379 56.6352 65.0473 56.6165 65.0648L55.4235 66.259C54.6161 67.0664 54.5212 68.318 55.1388 69.2297L54.247 70.1215C54.2295 70.1391 54.2197 70.1629 54.2197 70.1877C54.2197 70.2125 54.2295 70.2363 54.247 70.2539L54.7438 70.7508C54.7626 70.7695 54.786 70.7777 54.8106 70.7777C54.8352 70.7777 54.8587 70.7684 54.8774 70.7508L55.7692 69.859C56.1641 70.1273 56.6235 70.2609 57.0829 70.2609C57.6829 70.2609 58.2829 70.0324 58.7411 69.5742L59.9352 68.3801C59.9716 68.3438 59.9716 68.284 59.9352 68.2477L59.4313 67.7438L60.213 66.9621C60.2493 66.9258 60.2493 66.866 60.213 66.8297L59.7841 66.4055Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1353_7494",
    x: 0,
    y: 77,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1353_7494",
    result: "effect2_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1353_7494",
    result: "effect3_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1353_7494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_1353_7494",
    x: 0,
    y: 0,
    width: 118,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1353_7494",
    result: "effect2_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1353_7494",
    result: "effect3_dropShadow_1353_7494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1353_7494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1353_7494",
    x: 47.126,
    y: 54.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1353_7494"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_7494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 91)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetchTooltipIcon);
export default __webpack_public_path__ + "static/media/fetchTooltipIcon.18d35414b8cf73faaf54c361768030e7.svg";
export { ForwardRef as ReactComponent };